<template>
  <div style="padding: 10px">
    <el-row class="box-row">
      <el-col :span="3" class="item-text">物料编码：</el-col>
      <el-col :span="4" class="item-value">{{ material.code }}</el-col>
      <el-col :span="3" class="item-text">物料名称：</el-col>
      <el-col :span="4" class="item-value">{{ material.name }}</el-col>
      <el-col :span="3" class="item-text">总库存：</el-col>
      <el-col :span="4" class="item-value">{{ totalStock }}</el-col>
    </el-row>

    <el-row class="box-row">
      <KfTableTitle title="库存明细"></KfTableTitle>

      <el-table :data="stockList" stripe :border="true">
        <el-table-column label="仓库" prop="wms_store.name@store_id"></el-table-column>
        <el-table-column label="库位" prop="wms_store_location.code@location_id"></el-table-column>
        <el-table-column label="批次日期" prop="batch_time"></el-table-column>
        <el-table-column label="库存" prop="cnt"></el-table-column>
      </el-table>
    </el-row>

    <el-row class="box-row">
      <KfTableTitle :title="tableTitle"></KfTableTitle>
      <el-table :data="applyList" stripe :border="true">
        <el-table-column label="申请人" prop="sys_user.full_name@apply_user_id"></el-table-column>
        <el-table-column label="数量" prop="cnt"></el-table-column>
        <el-table-column label="申请时间" prop="apply_time"></el-table-column>
        <el-table-column label="备注" prop="apply_remark"></el-table-column>
      </el-table>
    </el-row>

    <el-card shadow="never">
      <el-form :model="formData" label-width="100px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="申请人：" class="item-value">
              {{ applyInfo['sys_user.full_name@apply_user_id'] }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请时间：" class="item-value">
              {{ applyInfo.apply_time }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="申请数量：" class="item-value">
              {{ applyInfo.cnt }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请备注：" class="item-value">
              {{ applyInfo.apply_remark }}
            </el-form-item>
          </el-col>
        </el-row>
        <div v-for="item in totalStockList" :key="item">
          <el-row>
            <el-col :span="6">
              <el-form-item label="仓库：" class="item-value">
                {{item.store_name}}
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="库位：" class="item-value">
                {{item.location_code}}
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="批次日期：" class="item-value">
                {{item.batch_time}}
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="库存：" class="item-value">
                {{item.cnt}}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发放数量：">
                <el-input-number v-model="item.approval_cnt" :min="0" style="width: 110px" ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-form-item label="备注：">
          <el-input type="textarea" v-model="formData.approval_remark" style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="agreeIn" :loading="loading">发放</el-button>
          <el-button @click="reject" :loading="loading">拒绝</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>

export default {
  name: "WmsApprovalIn",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      material: {},
      stockList: [],
      applyList: [],
      applyInfo: {},
      totalStockList:[],
      formData: {
        approval_remark: ''
      },
      loading: false
    }
  },
  computed: {
    totalStock() {
      let stock = 0;
      this.stockList.forEach(item => {
        let cnt = item.cnt || 0;
        stock += cnt;
      })
      return stock;
    },
    tableTitle() {
      return '【' + this.material.code + '】领料申请'
    }
  },
  created() {
    this.$axios.post('/frame/method/callMethod', {
      method: 'wmsPersonalService.initApprovalInData',
      id: this.parentData.id
    }).then(response => {
      let res = response.data;
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }

      this.material = res.data.material || {}
      this.stockList = res.data.stockList || []
      this.applyList = res.data.applyList || []
      this.applyInfo = res.data.applyInfo || {}
      this.totalStockList = res.data.totalStockList || {}

    }, error => {
      return this.$message.error(error.message)
    })
  },
  methods: {
    reject() {
      this.loading = true
      this.$axios.post('/frame/method/callMethod', {
        method: 'wmsPersonalService.reject',
        id: this.parentData.id,
        approval_remark: this.formData.approval_remark
      }).then(response => {
        this.loading = false
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.$message.success(res.data);
      }, error => {
        this.loading = false
        return this.$message.error(error.message)
      })
    },
    agreeIn() {

      this.loading = true
      this.$axios.post('/frame/method/callMethod', {
        method: 'wmsPersonalService.agreeIn',
        id: this.parentData.id,
        approval_remark: this.formData.approval_remark,
        totalStockList:this.totalStockList
      }).then(response => {
        this.loading = false
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.$message.success(res.data);
      }, error => {
        this.loading = false
        return this.$message.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
.box {
  padding: 10px
}

.box-row {
  margin-bottom: 20px;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}
</style>